import StatusBadge from "@/components/StatusBadge";

function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "—" : d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
}

function fmtMinutes(mins) {
  if (mins == null) return "—";
  return `${Math.floor(mins / 60)}h ${Math.round(mins % 60)}m`;
}

export default function AttendanceHistoryTable({ records }) {
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden" data-testid="attendance-history-table">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-[#4B5563] border-b border-[#E2E8F0] bg-[#F8F9FA]">
            <th className="px-4 py-2.5 font-medium">Date</th>
            <th className="px-4 py-2.5 font-medium">Check-In</th>
            <th className="px-4 py-2.5 font-medium">Check-Out</th>
            <th className="px-4 py-2.5 font-medium">Total</th>
            <th className="px-4 py-2.5 font-medium">Break</th>
            <th className="px-4 py-2.5 font-medium">Net Hours</th>
            <th className="px-4 py-2.5 font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          {records.length === 0 && (
            <tr><td colSpan={7} className="px-4 py-6 text-center text-[#4B5563]">No attendance records yet.</td></tr>
          )}
          {records.map((r) => (
            <tr key={r.id} data-testid={`attendance-row-${r.id}`} className="border-b border-[#E2E8F0] last:border-b-0">
              <td className="px-4 py-2.5 text-[#1C1C1E] font-medium">{r.date}</td>
              <td className="px-4 py-2.5 text-[#4B5563]">{fmtTime(r.check_in_time)}</td>
              <td className="px-4 py-2.5 text-[#4B5563]">{fmtTime(r.check_out_time)}</td>
              <td className="px-4 py-2.5 text-[#4B5563]">{fmtMinutes(r.total_minutes)}</td>
              <td className="px-4 py-2.5 text-[#4B5563]">{fmtMinutes(r.break_minutes)}</td>
              <td className="px-4 py-2.5 text-[#1C1C1E] font-medium">{fmtMinutes(r.net_minutes)}</td>
              <td className="px-4 py-2.5"><StatusBadge value={r.status} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
